import Swiper from "swiper";
import { Pagination, Navigation, Scrollbar, Autoplay } from "swiper/modules";
import { elementsMaxHeight } from '@/utils/common';
const SwiperCarousel = {
    init: () => {
        const $swiperCarousels = document.querySelectorAll('.swiper-carousel');
        if ($swiperCarousels.length === 0)
            return;
        SwiperCarousel.loop($swiperCarousels);
    },
    setElementsHeight: ($slider) => {
        const $swiperSlides = $slider.querySelectorAll('.swiper-slide');
        $swiperSlides.forEach((element) => {
            element.style.height = ``;
        });
        const maxHeight = elementsMaxHeight($swiperSlides);
        $swiperSlides.forEach((element) => {
            element.style.height = `${maxHeight}px`;
        });
    },
    loop: (elements) => {
        elements.forEach((element) => {
            const $swiper = element.querySelector('.swiper');
            const $btnPrev = element.querySelector('.swiper-button-prev');
            const $btnNext = element.querySelector('.swiper-button-next');
            const $scrollBar = element.querySelector('.swiper-scrollbar');
            const $swiperPagination = element.querySelector(".swiper-pagination .container");
            const dataset = element.dataset;
            let config = typeof dataset.swiperConfig !== "undefined" ? JSON.parse(dataset.swiperConfig) : {};
            new Swiper($swiper, {
                modules: [Pagination, Navigation, Scrollbar, Autoplay],
                slidesPerView: config.slidesPerView || 'auto',
                direction: config.direction || 'horizontal',
                spaceBetween: config.spaceBetween || 30,
                breakpoints: config.breakpoints,
                grabCursor: true,
                navigation: {
                    nextEl: $btnNext,
                    prevEl: $btnPrev,
                },
                autoplay: config.autoplay,
                scrollbar: {
                    el: $scrollBar,
                    hide: false,
                    draggable: true,
                },
                pagination: {
                    el: $swiperPagination,
                    clickable: true,
                },
            });
        });
    },
};
export default SwiperCarousel;
